// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__cLM2H","title":"Home_title__SxjOB"};